export const SAVE_PAYOUT_ACCOUNT = "SAVE_PAYOUT_ACCOUNT";
export const SAVE_PAYOUT_ACCOUNT_SUCCESS = "SAVE_PAYOUT_ACCOUNT_SUCCESS";
export const SAVE_PAYOUT_ACCOUNT_FAILURE = "SAVE_PAYOUT_ACCOUNT_FAILURE";

export const PAYOUT_ACCOUNT = "PAYOUT_ACCOUNT";
export const PAYOUT_ACCOUNT_SUCCESS = "PAYOUT_ACCOUNT_SUCCESS";
export const PAYOUT_ACCOUNT_FAILURE = "PAYOUT_ACCOUNT_FAILURE";

export const CARD_PAYMENT = "CARD_PAYMENT";
export const CARD_PAYMENT_SUCCESS = "CARD_PAYMENT_SUCCESS";
export const CARD_PAYMENT_FAILURE = "CARD_PAYMENT_FAILURE";

export const MANUAL_PAYMENT = "MANUAL_PAYMENT";
export const MANUAL_PAYMENT_SUCCESS = "MANUAL_PAYMENT_SUCCESS";
export const MANUAL_PAYMENT_FAILURE = "MANUAL_PAYMENT_FAILURE";

export const OTHER_PAYMENT = "OTHER_PAYMENT";
export const OTHER_PAYMENT_SUCCESS = "OTHER_PAYMENT_SUCCESS";
export const OTHER_PAYMENT_FAILURE = "OTHER_PAYMENT_FAILURE";

export const RESET_PAYOUT = "RESET_PAYOUT";

export interface PayoutState {
  savePayoutAccountSuccess: string | null;
  savePayoutAccountError: string | null;
  savePayoutAccountLoading: boolean;

  payoutAccountSuccess: string | null;
  payoutAccountError: string | null;
  payoutAccountLoading: boolean;
  savedData: any;
  payoutAccountList: any;

  cardPaymentSuccess: string | null;
  cardPaymentError: string | null;
  cardPaymentLoading: boolean;

  manualPaymentSuccess: string | null;
  manualPaymentError: string | null;
  manualPaymentLoading: boolean;

  otherPaymentSuccess: string | null;
  otherPaymentError: string | null;
  otherPaymentLoading: boolean;
}

interface GetPaymentAccount {
  type: typeof PAYOUT_ACCOUNT;
  payload: any;
}

interface GetPaymentAccountSucess {
  type: typeof PAYOUT_ACCOUNT_SUCCESS;
  payload: any;
}

interface GetPaymentAccountFailure {
  type: typeof PAYOUT_ACCOUNT_FAILURE;
  payload: string;
}

interface AddPaymentAccount {
  type: typeof SAVE_PAYOUT_ACCOUNT;
  payload: any;
}

interface AddPaymentAccountSucess {
  type: typeof SAVE_PAYOUT_ACCOUNT_SUCCESS;
  payload: any;
}

interface AddPaymentAccountFailure {
  type: typeof SAVE_PAYOUT_ACCOUNT_FAILURE;
  payload: string;
}

interface CardPaymentAccount {
  type: typeof CARD_PAYMENT;
  payload: any;
}

interface CardPaymentAccountSucess {
  type: typeof CARD_PAYMENT_SUCCESS;
  payload: any;
}

interface CardPaymentAccountFailure {
  type: typeof CARD_PAYMENT_FAILURE;
  payload: string;
}

interface ManualPaymentAccount {
  type: typeof MANUAL_PAYMENT;
  payload: any;
}

interface ManualPaymentAccountSucess {
  type: typeof MANUAL_PAYMENT_SUCCESS;
  payload: any;
}

interface ManualPaymentAccountFailure {
  type: typeof MANUAL_PAYMENT_FAILURE;
  payload: string;
}

interface OtherPaymentAccount {
  type: typeof OTHER_PAYMENT;
  payload: any;
}

interface OtherPaymentAccountSucess {
  type: typeof OTHER_PAYMENT_SUCCESS;
  payload: any;
}

interface OtherPaymentAccountFailure {
  type: typeof OTHER_PAYMENT_FAILURE;
  payload: string;
}

interface ResetPayoutAction {
  type: typeof RESET_PAYOUT;
}

export type PayoutTypes =
  | GetPaymentAccount
  | GetPaymentAccountSucess
  | GetPaymentAccountFailure
  | AddPaymentAccount
  | AddPaymentAccountSucess
  | AddPaymentAccountFailure
  | ManualPaymentAccount
  | ManualPaymentAccountSucess
  | ManualPaymentAccountFailure
  | OtherPaymentAccount
  | OtherPaymentAccountSucess
  | OtherPaymentAccountFailure
  | CardPaymentAccount
  | CardPaymentAccountSucess
  | CardPaymentAccountFailure
  | ResetPayoutAction;
